module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA4.de0effe5.jpg";